var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('customer-accounting-control-table',{attrs:{"own-consultant":_vm.consultant_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }